import {Component, ChangeDetectionStrategy} from '@angular/core';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AbstractStyleComponent} from '../abstract-style/abstract-style.component';

@Component({
  selector: 'app-border',
  imports: [
    ReactiveFormsModule,
    FormsModule
],
  templateUrl: './border.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './border.component.scss'
})
export class BorderComponent extends AbstractStyleComponent {
  protected styles: any = [
    {value: 'none', label: 'No border'},
    {value: 'solid', label: 'Line'},
    {value: 'dotted', label: 'Dotted'},
    {value: 'dashed', label: 'Dashed'},
  ];

  color: string | null = null;
  style: string | null = null;
  width: number | null = null;
  radius: number | null = null;

  getValue(): any {
    const value: any = {
      style: this.style,
      color: null,
      width: null,
      radius: this.formatPixelValue(this.radius),
    }

    if (this.hasBorder()) {
      value.color = this.color ?? null;
      value.width = this.formatPixelNonZeroValue(this.width);
    }

    return value;
  }

  setValue(value: any): void {
    this.color = value['color'];
    this.style = value['style'];
    this.width = this.parseNumberValue(value['width']);
    this.radius = this.parseNumberValue(value['radius'], 0);
  }

  hasBorder(): boolean {
    return this.style !== 'none';
  }

  checkWidth(): void {
    if (this.width !== null && this.width < 1) {
      this.width = 1;
    }
  }

  checkRadius(): void {
    if (this.radius !== null && this.radius < 0) {
      this.radius = 0;
    }
  }
}
